var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-order-record",
      attrs: {
        title: "订单操作记录",
        visible: _vm.visibleDialog,
        width: "520px",
        top: "calc(50vh - 220px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "record-con",
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: { prop: "time", label: "日期", width: "168" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "time" }, [
                          _vm._v(" " + _vm._s(scope.row.operationTime) + " "),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "operatorName", label: "操作人", width: "140" },
              }),
              _c("el-table-column", {
                attrs: { prop: "operationContent", label: "操作结果" },
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.page,
              "page-size": 10,
              layout: "total,prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "current-change": _vm.fetchData,
              "update:currentPage": function ($event) {
                _vm.page = $event
              },
              "update:current-page": function ($event) {
                _vm.page = $event
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }